<template>
  <div class="filter" @click.stop="isChecked ? emit('uncheck') : emit('check')">
    <button v-focus class="filter__button">
      <label class="filter__label">{{ label }}</label>
      <span v-if="itemCount" class="item-count">{{ itemCount }}</span>
      <div class="no-pointer">
        <SwitchToggle :checked="isChecked" :color="color" />
      </div>
    </button>
  </div>
</template>

<script setup>
import SwitchToggle from "@follaw-fr/components/reusable/atoms/SwitchToggle.vue";

defineProps({
  label: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    required: true,
  },
  itemCount: {
    type: Number,
    default: null,
  },
  isChecked: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["check", "uncheck"]);
</script>

<style lang="scss" scoped>
.filter {
  position: relative;
  -webkit-user-select: none;
  user-select: none;
}

.no-pointer {
  pointer-events: none;
}

.filter__button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  height: 30px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.0784313725);
  padding: 4px 15px;
  border-radius: 15px;
  background: white;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 0px 5px 1px var(--clr-p9);
    font-weight: 400;
  }

  .item-count {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50rem;
    min-width: 20px;
    height: 20px;
    padding: 3px;
    font-size: 0.875em;
    color: white;
    background-color: var(--clr-p5);
  }
}

.filter__label {
  cursor: pointer;
}
</style>
